import { UrlParamsReplace } from './index';

export const MESSAGE_URL = () => UrlParamsReplace('/messages');

export const KNOW_MORE_MESSAGE_URL = () => UrlParamsReplace('/knowmore');
